import { customerUpdateDescription as description } from './description';
import { updateCustomer as execute } from './execute';

export { description, execute };
